export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-m@2x.51c61c79.png";